<template>
    <widgetModal :title="!notification_form.id ? 'New Notification' : 'Compose Notification'"
        subtitle="You can add information directly from this form" btnlefttext="Send" btncentertext="Cancel"
        btnrighttext="Save as draft" :leftloading="send_notification_loading" :rightloading="save_notification_loading"
        :centerloading="false" :footerhidden="false" footer_padding="20px 20px" header_padding="20px 20px"
        body_padding="0px 20px" width="580px" @onLeftClick="sendNotification()" @onCenterClick="onCancel"
        @onRightClick="saveNotificationAsDraft()">
        <div class="widget-modal-body-noscoll">
            <widgetInputWrapper title="Send to*">
                <widgetClassDropdown v-model="notification_form.classes"></widgetClassDropdown>
            </widgetInputWrapper>
            <widgetInputWrapper title="Title">
                <widgetInput v-model="notification_form.title" type="text" placeholder="Add Your Title"></widgetInput>
            </widgetInputWrapper>
            <widgetInputWrapper title="Action">
                <widgetSelect :opt="[
                    { label: 'Other', value: 'other' },
                    { label: 'Invitation', value: 'invitation' },
                    { label: 'Assign internship', value: 'assign_interneship' },
                ]" placeholder="Select action" v-model="notification_form.action"></widgetSelect>
            </widgetInputWrapper>
            <widgetInputWrapper title="Message*">
                <html-editor placeholder="Type here..." v-model="notification_form.message" id="edit-descr" />
            </widgetInputWrapper>
        </div>
    </widgetModal>
</template>
  
<script>
export default {
    name: "",
    components: {},
    props: {
        value: {
            type: Object,
            default: null,
        },
        phase: {
            type: String,
            default: "",
        },
        template: {
            type: Object,
            default: null,
        },
    },
    data: () => {
        return {
            send_notification_loading: false,
            save_notification_loading: false,
            notification_form: {
                id: null,
                title: "",
                action: "other",
                message: "",
                phase: "",
                classes: {
                    is_all_classes: false,
                    is_my_classes: false,
                    selected_classes: [],
                },
            },
        };
    },
    mounted() {
        let vm = this;
        if (vm.template) {
            vm.updateWithTemplate(vm.template);
        } else {
            if (vm.value) {
                vm.updateNotification(vm.value);
            } else {
                vm.newNotification();
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        updateWithTemplate(item) {
            let vm = this;
            vm.notification_form = {
                id: null,
                title: item.title,
                action: "other",
                message: item.description,
                phase: "",
                classes: {
                    is_all_classes: false,
                    is_my_classes: false,
                    selected_classes: [],
                },
            };
        },
        updateNotification(item) {
            let vm = this;
            vm.notification_form.id = item.id;
            vm.notification_form.title = item.title;
            vm.notification_form.action = item.action;
            vm.notification_form.message = item.description;
        },
        newNotification() {
            let vm = this;
            vm.notification_form = {
                id: null,
                title: "",
                action: "other",
                message: "",
                phase: "",
                classes: {
                    is_all_classes: false,
                    is_my_classes: false,
                    selected_classes: [],
                },
            };
        },
        sendNotification() {
            let vm = this;
            const rules = {
                title: {
                    run: (value) => {
                        if (!value) {
                            return "Please add notification title";
                        }
                        return false;
                    },
                },
                message: {
                    run: (value) => {
                        if (!value) {
                            return "Please add notification message";
                        }
                        return false;
                    },
                },
            };
            if (vm.$isFieldsValidated(vm.notification_form, rules)) {
                vm.send_notification_loading = true;
                vm.notification_form.phase = vm.phase;
                vm.$store
                    .dispatch("COMMUNICATION_NOTIFICATION_SEND_NOTIFICATION", vm.notification_form)
                    .then((responce) => {
                        vm.send_notification_loading = false;
                        vm.$emit("notificationSent", vm.notification_form);
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Notification sent successfully",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.send_notification_loading = false;
                        vm.$notify({
                            group: "status",
                            title: "Warning",
                            text: "Something wrong while sending notification",
                            type: "warn",
                            duration: 3000,
                        });
                    });

            }

        },
        saveNotificationAsDraft() {
            let vm = this;
            if (!vm.notification_form.id) {
                vm.notification_form.phase = vm.phase;
                vm.save_notification_loading = true;
                vm.$store
                    .dispatch("PROCESSMESSAGE_NOTIFICATION_ADD_NEW", vm.notification_form)
                    .then((responce) => {
                        vm.save_notification_loading = false;
                        vm.$emit("saved");
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Notification is now added",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.save_notification_loading = false;
                        vm.$notify({
                            group: "status",
                            title: "Warning",
                            text: "Something wrong while adding notification",
                            type: "warn",
                            duration: 3000,
                        });
                    });
            } else {
                vm.notification_loading = true;
                vm.$store
                    .dispatch("PROCESSMESSAGE_NOTIFICATION_UPDATE", vm.notification_form)
                    .then((responce) => {
                        vm.$emit("saved");
                        vm.notification_loading = false;
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Notification is now updated",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.notification_loading = false;
                        vm.$notify({
                            group: "status",
                            title: "Warning",
                            text: "Something wrong while updating notification",
                            type: "warn",
                            duration: 3000,
                        });
                    });
            }
        },
        onCancel() {
            let vm = this;
            vm.$emit("close");
        },
    },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
</style>
  
  
  